import React from 'react'
import styled from "styled-components";
import { colors } from "../../../utils/theme";

import ZonaAfectadaImage from '../../../assets/img/ZonaAfectada.png';


const Container = styled.div`


h2{
  background-color: ${colors.gris};
  color: ${colors.third};
  text-align: center;
  padding: 2rem 0;

  @media (max-width: 500px) {
      font-size: 1.2rem;
    }

    @media (max-width: 325px) {
      font-size: 1rem;
    }
}

article{
  width: 90%;
  margin: 0 auto;
  height: 100%;
  margin-bottom: 5rem;
  img{
    width: 100%;
    height: 100%;
  }
}
  
`

export const AffectedAreaComponent = () => {
  return (
    <Container>
      <h2>CONFIRMA TU AREA AFECTADA</h2>
      <article>
      <img src={ZonaAfectadaImage} alt="Zona Afectada" />
      </article>

    </Container>
  )
}
